module.exports = __webpack_public_path__ + "static/originals-8ed980e978f737063acbd44deeb57dc9.jpg";